import { Component, OnInit } from "@angular/core";
import CustomStore from "devextreme/data/custom_store";
import { lastValueFrom } from "rxjs";
import { FtpServer } from "../../Model/FtpServer";
import { FtpDataSourceImportJobSettings } from "../../Model/recurringJobs/ftp/ftpDataSourceImportJobSettings";
import { Message } from "../../Model/System/Message";
import { FtpServerService } from "../../Services/ftp/ftpServer.service";
import { FtpDataSourceImportJobsService } from "../../Services/ftp/ftpDataSourceImportJobs.service";
import { LoginService } from "../../Services/login.service";
import { SystemService } from "../../Services/system.service";
import { InitNewRowEvent } from "devextreme/ui/data_grid";

@Component({
    selector: "FtpDataSourceImport",
    templateUrl: "ftpDataSourceImport.component.html",
    standalone: false
})
export class FtpDataSourceImportComponent implements OnInit {
  dataSource: any = {};
  ftpServers: FtpServer[] = [];

  constructor(public ftpServerService: FtpServerService, public ftpDataSourceImportJobsService: FtpDataSourceImportJobsService,
    public loginService: LoginService, public systemService: SystemService) {
    this.dataSource.store = new CustomStore({
      key: "id",
      load: function (loadOptions: any) {
        return ftpDataSourceImportJobsService.getAll(loginService.currentCustomer.id).toPromise()
          .then((data: FtpDataSourceImportJobSettings[]) => {
            data.forEach((f: FtpDataSourceImportJobSettings) => {
              f.time = new Date(f.time);
            });
            return data;
          });
      },
      insert: function (value) {
        value.id = 0;
        value.customerId = loginService.currentCustomer.id;
        return ftpDataSourceImportJobsService.update(value, loginService.currentCustomer.id).toPromise();
      },
      update: function (key, values) {
        return ftpDataSourceImportJobsService.get(key).toPromise()
          .then((data: FtpDataSourceImportJobSettings) => {
            const updatedData: FtpDataSourceImportJobSettings = {
              ...data,
              ...values,
            };

            if(updatedData.active){
              updatedData.timesFailed = 0;
            }
            return ftpDataSourceImportJobsService.update(updatedData, loginService.currentCustomer.id).toPromise()
              .then((data: FtpDataSourceImportJobSettings) => {
                return data;
              });
          });
      },
      remove: function (key) {
        return lastValueFrom(ftpDataSourceImportJobsService.delete(key, loginService.currentCustomer.id)).then((success) => {
          return;
        });
      }
    });
  }

  async ngOnInit() {
    this.ftpServers = await lastValueFrom(this.ftpServerService.getAllServer());
  }

  async onInitNewRow(event: InitNewRowEvent<FtpDataSourceImportJobSettings>) {
    event.data.active = true;
  }

  isManager(): boolean {
    if (this.loginService.currentUser.currentClaim == "MANAGER" || this.loginService.currentUser.currentClaim == "ADMIN")
      return true;
    return false;
  }

  getTime(rowData): string {
    if (rowData.time instanceof String)
      rowData.time = new Date(rowData.time);

    return rowData.time;
  }

  getLastRun(rowData): string {
    if (rowData.lastRun instanceof String)
      rowData.lastRun = new Date(rowData.lastRun);

    return rowData.lastRun;
  }

  run(d) {
    this.ftpDataSourceImportJobsService.run(d.data).subscribe(() => {
      this.systemService.notify(new Message("Job wurde manuell gestartet, er entfernt sich automatisch, sollte er keine Datei importieren."));
    }, error => {
      let msg = new Message();
      msg.type = "Error";
      msg.message = "Fehler beim manuellen starten";
      this.systemService.notify(msg);
    });
  }
}
